import * as React from 'react';
import styled, { css } from 'styled-components';
import Flex from '../flex';

export interface InputSplitWrapper {
  className?: string;
  inHalf?: boolean;
  margin?: string;
  bigMargin?: boolean;
  firstSmaller?: boolean;
  firstBigger?: boolean;
  lastSmaller?: boolean;
  onlyOneChild?: boolean;
}

const MARGIN = '5px';

export const InputSplitWrapper: React.FC<InputSplitWrapper> = (props) => (
  <Flex className={props.className}>{props.children}</Flex>
);

export default styled(InputSplitWrapper)`
  ${(props) =>
    props.margin
      ? css`
          margin: ${props.margin};
        `
      : css`
          margin-bottom: ${MARGIN};
        `};
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobileL} {
    ${(props) =>
      props.margin
        ? css`
            margin: ${props.margin};
          `
        : css`
            margin-bottom: ${MARGIN};
          `};
    flex-direction: row;
  }

  ${(props) =>
    props.bigMargin
      ? css`
          margin-bottom: 8px;
          @media ${({ theme }) => theme.device.mobileL} {
            margin-bottom: 15px;
          }
        `
      : null}

  ${(props) =>
    props.children
      ? css`
          & > :first-child {
            width: ${props.onlyOneChild ? '100% !important' : 'auto'};
            margin-bottom: ${MARGIN};

            @media ${({ theme }) => theme.device.mobileL} {
              width: ${props.inHalf
                ? css`calc(50% - (${MARGIN} / 2))`
                : props.firstSmaller
                ? css`calc(40% - (${MARGIN} / 2))`
                : props.firstBigger
                ? css`calc(70% - (${MARGIN} / 2))`
                : props.lastSmaller
                ? css`calc(75% - (${MARGIN} / 2))`
                : 'auto'};
              margin-right: ${MARGIN};
              margin-bottom: 0;
            }
            @media ${({ theme }) => theme.device.laptop} {
              width: ${props.inHalf
                ? css`calc(50% - (${MARGIN} / 2))`
                : props.firstSmaller
                ? css`calc(35% - (${MARGIN} / 2))`
                : props.firstBigger
                ? css`calc(65% - (${MARGIN} / 2))`
                : props.lastSmaller
                ? css`calc(75% - (${MARGIN} / 2))`
                : 'auto'};
              margin-right: ${MARGIN};
              margin-bottom: 0;
            }
            @media ${({ theme }) => theme.device.laptopL} {
              width: ${props.inHalf
                ? css`calc(50% - (${MARGIN} / 2))`
                : props.firstSmaller
                ? css`calc(40% - (${MARGIN} / 2))`
                : props.firstBigger
                ? css`calc(70% - (${MARGIN} / 2))`
                : props.lastSmaller
                ? css`calc(80% - (${MARGIN} / 2))`
                : 'auto'};
              margin-right: ${MARGIN};
              margin-bottom: 0;
            }
          }

          & > :last-child {
            width: auto;
            flex-grow: 0;
            flex-shrink: 0;
            margin-bottom: calc(${MARGIN} * 2);

            @media ${({ theme }) => theme.device.mobileL} {
              width: ${props.inHalf
                ? css`calc(50% - (${MARGIN} / 2))`
                : css`calc(40% - (${MARGIN} / 2))`};
              margin-bottom: 0;
            }
          }

          ${props.firstSmaller
            ? css`
                & > :first-child {
                  @media ${({ theme }) => theme.device.mobileL} {
                    width: calc(40% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptop} {
                    width: calc(35% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptopL} {
                    width: calc(40% - (${MARGIN} / 2));
                  }
                }
                & > :last-child {
                  @media ${({ theme }) => theme.device.mobileL} {
                    width: calc(60% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptop} {
                    width: calc(65% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptopL} {
                    width: calc(60% - (${MARGIN} / 2));
                  }
                }
              `
            : null}

          ${props.firstBigger
            ? css`
                & > :first-child {
                  @media ${({ theme }) => theme.device.mobileL} {
                    width: calc(70% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptop} {
                    width: calc(75% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptopL} {
                    width: calc(70% - (${MARGIN} / 2));
                  }
                }
                & > :last-child {
                  @media ${({ theme }) => theme.device.mobileL} {
                    width: calc(30% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptop} {
                    width: calc(35% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptopL} {
                    width: calc(30% - (${MARGIN} / 2));
                  }
                }
              `
            : null}
      ${props.lastSmaller
            ? css`
                & > :first-child {
                  @media ${({ theme }) => theme.device.mobileL} {
                    width: calc(75% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptop} {
                    width: calc(75% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptopL} {
                    width: calc(80% - (${MARGIN} / 2));
                  }
                }
                & > :last-child {
                  @media ${({ theme }) => theme.device.mobileL} {
                    width: calc(25% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptop} {
                    width: calc(25% - (${MARGIN} / 2));
                  }
                  @media ${({ theme }) => theme.device.laptopL} {
                    width: calc(20% - (${MARGIN} / 2));
                  }
                }
              `
            : null}
        `
      : null}
`;
